import { render, staticRenderFns } from "./release-notes.vue?vue&type=template&id=2c931618&"
var script = {}
import style0 from "./release-notes.vue?vue&type=style&index=0&id=2c931618&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports